/** Guarda as animações do componente e desfaz tudo ao sair da tela. */
const mixinMotion = {
  created() {
    this.motionRuns = [];
  },

  beforeDestroy() {
    this.motionRuns.forEach((run) => run.revert());
    this.motionRuns = [];
  },

  methods: {
    trackMotion(run) {
      if (run) this.motionRuns.push(run);

      return run;
    }
  }
};

export default mixinMotion;
